import React from 'react';
import { motion } from 'framer-motion';

// Design System Constants - Matching New Design
const DESIGN_SYSTEM = {
  container: {
    xl: 'max-w-7xl'
  },
  text: {
    caption: 'text-sm md:text-base leading-relaxed'
  },
  buttons: {
    primary: 'bg-gradient-to-r from-ripple-blue to-ripple-blue-light hover:from-ripple-blue/90 hover:to-ripple-blue-light/90 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg shadow-ripple-blue/25 border border-ripple-blue/30',
    secondary: 'bg-white/10 hover:bg-white/15 backdrop-blur-md border border-white/20 hover:border-white/30 text-white font-medium rounded-lg transition-all duration-300'
  }
};

// Professional Web3 Icons  
const TwitterIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
  </svg>
);

const LinkedInIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const GitHubIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
  </svg>
);

const DiscordIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

const WaveIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
  </svg>
);

const Footer: React.FC = () => {
  const handleLaunchApp = () => {
    window.location.href = '/app';
  };

  const socialLinks = [
    {
      name: 'Twitter',
      href: 'https://twitter.com/rippleone',
      icon: <TwitterIcon className="w-4 h-4 text-white" />
    },
    {
      name: 'LinkedIn',
      href: 'https://linkedin.com/company/rippleone',
      icon: <LinkedInIcon className="w-4 h-4 text-white" />
    },
    {
      name: 'GitHub',
      href: 'https://github.com/rippleone',
      icon: <GitHubIcon className="w-4 h-4 text-white" />
    },
    {
      name: 'Discord',
      href: 'https://discord.gg/rippleone',
      icon: <DiscordIcon className="w-4 h-4 text-white" />
    }
  ];

  const platformLinks = [
    { name: 'Swap', href: '/app/swap' },
    { name: 'Earn', href: '/app/vault' },
    { name: 'Bridge', href: '/app/bridge' },
    { name: 'Analytics', href: '/app/dashboard' }
  ];

  const resourceLinks = [
    { name: 'Documentation', href: '#' },
    { name: 'API Reference', href: '#' },
    { name: 'Bug Bounty', href: '#' },
    { name: 'Security', href: '#' }
  ];

  const companyLinks = [
    { name: 'About', href: '#' },
    { name: 'Blog', href: '#' },
    { name: 'Careers', href: '#' },
    { name: 'Contact', href: '#' }
  ];

  return (
    <footer className="relative bg-slate-900/95 backdrop-blur-xl border-t border-slate-700/30">
      {/* Subtle Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute w-32 h-32 rounded-full bg-ripple-blue/20 top-8 left-8 animate-pulse-slow"></div>
        <div className="absolute w-24 h-24 rounded-full bg-accent-blue/15 bottom-8 right-8 animate-float"></div>
      </div>

      <div className={`${DESIGN_SYSTEM.container.xl} mx-auto px-6 sm:px-8 lg:px-12 xl:px-16 py-8 relative z-10`}>
        
        {/* Main Footer Content - More Compact */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8 mb-8">
          
          {/* Brand Section */}
          <div className="lg:col-span-2 space-y-3">
            <div className="flex items-center space-x-2">
              <div className="relative">
                <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="drop-shadow-lg">
                  <defs>
                    <linearGradient id="rippleGradientFooter" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" style={{stopColor:"#4FC3F7", stopOpacity:1}} />
                      <stop offset="50%" style={{stopColor:"#2196F3", stopOpacity:1}} />
                      <stop offset="100%" style={{stopColor:"#1976D2", stopOpacity:1}} />
                    </linearGradient>
                  </defs>
                  
                  {/* Water Ripple Icon */}
                  <g transform="translate(4, 4)">
                    {/* Outer ripple */}
                    <circle cx="12" cy="12" r="10" fill="none" stroke="url(#rippleGradientFooter)" strokeWidth="1.2" opacity="0.3"/>
                    {/* Middle ripple */}
                    <circle cx="12" cy="12" r="6.5" fill="none" stroke="url(#rippleGradientFooter)" strokeWidth="1.2" opacity="0.6"/>
                    {/* Inner ripple */}
                    <circle cx="12" cy="12" r="3.5" fill="none" stroke="url(#rippleGradientFooter)" strokeWidth="1.2" opacity="0.9"/>
                    {/* Center drop */}
                    <circle cx="12" cy="12" r="1.2" fill="url(#rippleGradientFooter)"/>
                  </g>
                </svg>
              </div>
              <span className="text-lg font-bold tracking-tight text-white">
                RippleOne
              </span>
            </div>
            
            <p className={`${DESIGN_SYSTEM.text.caption} text-slate-400 max-w-md`}>
              The first XRP DeFi platform built for real-world usability. 
              Transform idle XRP into active yield-generating assets with institutional-grade security.
            </p>

            {/* Social Links - More Compact */}
            <div className="flex items-center space-x-2">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 rounded-lg bg-slate-800/50 hover:bg-slate-700/60 border border-slate-700/40 hover:border-ripple-blue/40 flex items-center justify-center transition-all duration-300"
                  whileHover={{ scale: 1.05, y: -1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Platform Links */}
          <div className="space-y-3">
            <h3 className="text-base font-semibold text-white">Platform</h3>
            <div className="space-y-1.5">
              {platformLinks.map((link) => (
                <motion.a
                  key={link.name}
                  href={link.href}
                  className="block text-sm text-slate-400 hover:text-white transition-colors duration-200"
                  whileHover={{ x: 2 }}
                >
                  {link.name}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Resources Links */}
          <div className="space-y-3">
            <h3 className="text-base font-semibold text-white">Resources</h3>
            <div className="space-y-1.5">
              {resourceLinks.map((link) => (
                <motion.a
                  key={link.name}
                  href={link.href}
                  className="block text-sm text-slate-400 hover:text-white transition-colors duration-200"
                  whileHover={{ x: 2 }}
                >
                  {link.name}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Company Links */}
          <div className="space-y-3">
            <h3 className="text-base font-semibold text-white">Company</h3>
            <div className="space-y-1.5">
              {companyLinks.map((link) => (
                <motion.a
                  key={link.name}
                  href={link.href}
                  className="block text-sm text-slate-400 hover:text-white transition-colors duration-200"
                  whileHover={{ x: 2 }}
                >
                  {link.name}
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        {/* Newsletter Signup - More Compact */}
        <motion.div
          className="mb-6 p-4 md:p-6 rounded-2xl bg-slate-800/40 backdrop-blur-md border border-slate-700/30"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center">
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">
                Stay Updated
              </h3>
              <p className="text-sm text-slate-400">
                Get the latest updates on new features, partnerships, and platform developments.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-3 py-2.5 rounded-lg bg-slate-800/60 border border-slate-700/50 text-white text-sm placeholder-slate-500 focus:border-ripple-blue/50 focus:outline-none transition-colors duration-200"
              />
              <motion.button
                className={`${DESIGN_SYSTEM.buttons.primary} px-6 py-2.5 text-sm`}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Subscribe
              </motion.button>
            </div>
          </div>
        </motion.div>

        {/* Bottom Section - More Compact */}
        <div className="pt-4 border-t border-slate-700/30">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3">
            
            {/* Copyright */}
            <div className="text-center md:text-left">
              <p className="text-sm text-slate-400">
                © 2025 RippleOne. All rights reserved.
              </p>
            </div>

            {/* Legal Links */}
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="text-sm text-slate-400 hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-sm text-slate-400 hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </a>
              <a
                href="#"
                className="text-sm text-slate-400 hover:text-white transition-colors duration-200"
              >
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 